










































































































































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import registryService from "@/services/registry.service";
import SerialEmbed from "@/components/SerialEmbed.vue";
import {
  BCard,
  BCardSubTitle,
  BCardText,
  BRow,
  BCol,
  BFormSelect,
  BInputGroup,
  BInputGroupAppend,
  BFormTextarea,
  BFormInput,
  BFormRow,
  BButton,
  BTooltip,
  BDropdown,
  BDropdownItem,
  BModal,
  BSpinner
} from "bootstrap-vue";
import { Serial } from "@/types";
import { DiscordLookupResult } from "@/services/registry.service";
import { AxiosError } from "axios";

@Component({
  components: {
    SerialEmbed,
    BCard,
    BCardSubTitle,
    BCardText,
    BRow,
    BCol,
    BFormSelect,
    BInputGroup,
    BInputGroupAppend,
    BFormTextarea,
    BFormInput,
    BFormRow,
    BButton,
    BTooltip,
    BDropdown,
    BDropdownItem,
    BModal,
    BSpinner
  },
  model: {
    prop: "request",
    event: "change"
  }
})
export default class SerialRequestCard extends Vue {
  @Prop({ type: Object, required: true }) readonly request!: Serial;
  @Prop({ type: Number, default: 0 }) readonly inEdit!: number;
  @Prop({ type: Boolean, default: false }) readonly showIssueButton!: boolean;
  @Prop({ type: String }) readonly warning!: string;

  private deleteUnlocked = false;
  revisionOptions: string[] = [
    "V0.0",
    "V0.1",
    "V0.2",
    "V1.0",
    "V1.5",
    "V1.6",
    "V1.8",
    "V2.0",
    "V2.1",
    "V2.2",
    "V2.4",
    "VS",
    "VL",
    "VT",
    "VK",
    "VPX",
    "VC"
  ];
  private editedRequest: Serial | null = null;
  private error: string | null = null;
  private showRedditEmbed = false;

  private showTransferModal = false;
  private issuing = false;
  private showConfirmTransferModal = false;
  private serialToTransfer: Serial | {} = {};
  private serialNumberToTransfer = "";
  private transferRecipient: DiscordLookupResult | null = null;

  // Discord validation state
  private discordValidation: {
    loading: boolean;
    valid: boolean | null;
    uid: string | null;
    avatarUrl: string | null;
    displayName: string | null;
    error: string | null;
  } = {
    loading: false,
    valid: null,
    uid: null,
    avatarUrl: null,
    displayName: null,
    error: null
  };
  private discordValidationTimeout: number | null = null;
  private discordValidationRequestId = 0; // Track request sequence to ignore stale responses

  // Cleanup on component unmount to prevent memory leaks
  beforeDestroy() {
    if (this.discordValidationTimeout) {
      clearTimeout(this.discordValidationTimeout);
      this.discordValidationTimeout = null;
    }
  }

  private get canSubmit(): boolean {
    if (!this.editedRequest) return false;
    // If discord_username is set, it must be validated
    if (this.editedRequest.discord_username) {
      return (
        this.discordValidation.valid === true && !this.discordValidation.loading
      );
    }
    return true;
  }

  private onDiscordUsernameChange(newValue: string) {
    // Clear any pending validation
    if (this.discordValidationTimeout) {
      clearTimeout(this.discordValidationTimeout);
    }

    if (!newValue || newValue.length < 2) {
      this.discordValidation = {
        loading: false,
        valid: null,
        uid: null,
        avatarUrl: null,
        displayName: null,
        error: null
      };
      return;
    }

    this.discordValidation.loading = true;
    this.discordValidation.valid = null;
    this.discordValidation.error = null;

    // Debounce: wait 500ms before validating
    this.discordValidationTimeout = window.setTimeout(() => {
      this.validateDiscordUsername(newValue);
    }, 500);
  }

  private async validateDiscordUsername(username: string) {
    // Track this request to ignore stale responses
    const requestId = ++this.discordValidationRequestId;

    try {
      const result: DiscordLookupResult = await registryService.lookupDiscordUser(
        username
      );

      // Ignore stale response if a newer request was made
      if (requestId !== this.discordValidationRequestId) {
        return;
      }

      // Validate response shape (API might return HTML if route not found)
      if (typeof result.valid !== "boolean") {
        throw new Error("Invalid API response");
      }
      this.discordValidation = {
        loading: false,
        valid: result.valid,
        uid: result.uid || null,
        avatarUrl: result.avatarUrl || null,
        displayName: result.displayName || null,
        error: result.error || null
      };
      // Store uid in editedRequest for submission
      if (result.valid && this.editedRequest && result.uid) {
        // eslint-disable-next-line @typescript-eslint/camelcase
        this.editedRequest.discord_uid = result.uid;
      }
    } catch (e) {
      // Ignore stale response if a newer request was made
      if (requestId !== this.discordValidationRequestId) {
        return;
      }

      console.error("Discord validation error:", e);
      this.discordValidation = {
        loading: false,
        valid: false,
        uid: null,
        avatarUrl: null,
        displayName: null,
        error: "Failed to validate Discord username"
      };
    }
  }

  private resetDiscordValidation() {
    if (this.discordValidationTimeout) {
      clearTimeout(this.discordValidationTimeout);
    }
    this.discordValidation = {
      loading: false,
      valid: null,
      uid: null,
      avatarUrl: null,
      displayName: null,
      error: null
    };
  }

  private updateRequest() {
    const keepStatus = this.request.status;
    this.request.status = "pending";

    registryService
      .updateRequest(
        this.request.userId,
        this.request.created.toString(),
        this.request
      )
      .then(() => {
        this.request.status = keepStatus;
      })
      .catch(e => {
        this.error =
          "Error: " + (e.response.data.errorMessage || e.response.data.message);
        this.$emit("error", this.error);
      });
  }

  private async handleDelete() {
    if (this.deleteUnlocked) {
      const result = await registryService
        .deleteRequest(this.request.userId, this.request.created.toString())
        .catch(e => {
          this.error =
            "Error: " +
            (e.response.data.errorMessage || e.response.data.message);
          this.$emit("error", this.error);
        });
      if (result === "success") {
        this.$emit("delete", this.request);
      }
      this.deleteUnlocked = false;
    } else {
      this.deleteUnlocked = true;
    }
    setTimeout(() => {
      this.deleteUnlocked = false;
    }, 2000);
  }

  private editModeStart() {
    this.editedRequest = this.unescapedRequest;
    // Reset validation state
    this.resetDiscordValidation();
    // Validate existing discord_username if present
    if (this.editedRequest.discord_username) {
      this.onDiscordUsernameChange(this.editedRequest.discord_username);
    }
    this.$emit("changeInEdit", this.inEdit + 1);
  }

  private editModeDone() {
    Object.assign(this.request, this.editedRequest);
    this.editedRequest = null;
    this.updateRequest();
    this.$emit("change", this.editedRequest);
    this.$emit("changeInEdit", this.inEdit - 1);
  }

  private editModeCancel() {
    this.editedRequest = null;
    this.$emit("changeInEdit", this.inEdit - 1);
  }

  private async duplicateRequest() {
    try {
      const newRequest = await registryService.duplicateRequest(
        this.request.userId,
        this.request.created.toString()
      );
      this.$emit("duplicated", newRequest);
    } catch (error) {
      this.error =
        (error as AxiosError)?.response?.data?.errorMessage ??
        "An unknown error occured."; //TODO create util for this
    }
  }

  private showNames(serial: Serial) {
    if (serial.reddit_username) {
      if (serial.discord_username) {
        return `${serial.reddit_username} (${serial.discord_username})`;
      } else {
        return serial.reddit_username;
      }
    } else {
      return serial.discord_username;
    }
  }

  private async openConfirmTransferModal() {
    this.error = null;
    this.transferRecipient = null;
    if (!this.request.discord_username) {
      this.error =
        "Error: request has no Discord username - edit the request and add one before transferring";
      this.$emit("error", this.error);
      return;
    }
    try {
      const recipient = await registryService.lookupDiscordUser(
        this.request.discord_username
      );
      if (!recipient.valid) {
        this.error =
          "Error: " +
          (recipient.error ||
            `Discord user "${this.request.discord_username}" not found`);
        this.$emit("error", this.error);
        return;
      }
      this.transferRecipient = recipient;
      this.serialToTransfer = await registryService.getSerial(
        this.serialNumberToTransfer
      );
      this.showConfirmTransferModal = true;
    } catch (e) {
      this.error =
        "Error: " +
        (e.response?.data?.errorMessage ||
          e.response?.data?.message ||
          "Unknown error");
      this.$emit("error", this.error);
    }
  }

  private async transferSerial() {
    this.error = null;
    try {
      await registryService.adminTransfer(
        this.request.userId,
        this.request.created.toString(),
        this.serialNumberToTransfer,
        this.request
      );
      this.$emit("transferred", this.request);
    } catch (e) {
      this.error =
        "Error: " +
        (e.response?.data?.errorMessage ||
          e.response?.data?.message ||
          "Unknown error");
      this.$emit("error", this.error);
    }
  }

  private async handleIssue() {
    this.issuing = true;
    try {
      // Set status to issued and call the API
      const requestToIssue = { ...this.request, status: "issued" };
      const result = await registryService.updateRequest(
        this.request.userId,
        this.request.created.toString(),
        requestToIssue
      );
      if (result && result.serial) {
        this.$emit("issued", { request: this.request, serial: result.serial });
      }
    } catch (e) {
      const errorMessage =
        "Error: " +
        (e.response?.data?.errorMessage ||
          e.response?.data?.message ||
          "Unknown error");
      this.error = errorMessage;
      this.$emit("error", errorMessage);
    }
    this.issuing = false;
  }

  private static htmlDecode(input: string): string | null {
    const doc = new DOMParser().parseFromString(input, "text/html");
    return doc.documentElement.textContent;
  }

  private get unescapedRequest(): Serial {
    return Object.fromEntries(
      Object.entries(this.request).map(([k, v]) => [
        k,
        typeof v === "string" ? SerialRequestCard.htmlDecode(v) : v
      ])
    ) as Serial;
  }
}
